export default __webpack_public_path__ + "static/media/Markers_Red Marker.e2217118.svg";